import { MouseEventHandler, ReactNode } from "react";

export const ClickableWrapper: React.FC<{
  onClick: MouseEventHandler<HTMLDivElement>;
  children?: ReactNode;
}> = ({ onClick, children }) => (
  <div onClick={onClick} style={{ cursor: "pointer" }} role="button">
    {children}
  </div>
);
